// SuccessCard.jsx
import React from "react";
import "./Card.css"; // Import the external CSS
import ReactDOM from "react-dom";
const FalseCard = ({ onClose, status }) => {
  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div className="modal">
        <h2>Photos are not {status} Try Again!</h2>
        <div className="modal-buttons">
          <button className="modal-cancel" onClick={onClose}>
            ok
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FalseCard;
